import config from "environment";
import { getRequest } from "./client";

const { baseApi } = config;

export enum NotificationAdapterType {
  EMAIL = "EMAIL",
  TEXT = "TEXT",
  SLACK = "SLACK",
  TEAMS = "TEAMS",
}

enum NotificationType {
  COMMENT_ON_YOUR_VIDEO = "COMMENT_ON_YOUR_VIDEO",
  REPLY_TO_YOUR_COMMENT = "REPLY_TO_YOUR_COMMENT",
}

export type NotificationSetting = {
  userId: string;
  adapterType: NotificationAdapterType;
  notificationType: NotificationType;
  enabled: Boolean;
};

export const getUserNotificationSettings = async (userId: string) => {
  const fetchURL = `${baseApi}/notifications/settings/${userId}`;
  return await getRequest<any["Reply"]>(
    fetchURL,
    "NotificationService/getNotificationSettings"
  );
};

export const disableNotificationSetting = async (
  notificationSettingId: string
) => {
  const fetchURL = `${baseApi}/notifications/disable/${notificationSettingId}`;
  return await getRequest<any["Reply"]>(
    fetchURL,
    "NotificationService/disableNotificationSetting"
  );
};

export const enableNotificationSetting = async (
  notificationSettingId: string
) => {
  const fetchURL = `${baseApi}/notifications/enable/${notificationSettingId}`;
  return await getRequest<any["Reply"]>(
    fetchURL,
    "NotificationService/enableNotificationSetting"
  );
};
